import { FIELD_SUBTEMPLATE_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Subtemplate } from "PFCore/types";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useActivityFormStore } from "../activity_form_store";

export const useSubtemplate = (): Subtemplate | null => {
  const subtemplateKey = useWatch({
    name: FIELD_SUBTEMPLATE_KEY
  });

  const subtemplates = useActivityFormStore((state) => state.subtemplates);

  return useMemo(
    () => subtemplates.find(({ subtemplate_key: key }) => subtemplateKey === key) ?? null,
    [subtemplateKey, subtemplates]
  );
};
